import Fetch from '../../../components/Fetch'
import PieChart from '../../../components/Pie'
import arrayize from './utils/arrayize'

export default function Pie( props ) {
  const { card, before: globalBefore } = props

  // prepare BEFORE
  let before = arrayize( card.before )
  if ( globalBefore )
    before = [ ...arrayize( globalBefore ), ...before ]

  return (
    <div className="one hs centered card graph paddig">
      <h1 className="text p121 uppercase">
        { card.title }
      </h1>

      <Fetch
        type="pie"
        endpoint={ card.endpoint }
        params={ card.params }
        useFilter={ card.useFilter }
        before={ before }
      >
        { ( data ) => ( <PieChart
          data={ data instanceof Array ? data : [ data ] }
          labelKey={ card.labelKey }
          valueKey={ card.valueKey }
        /> ) }
      </Fetch>
    </div>
  )
}
